<template>
  <form
    autocomplete="off"
    class="admin-service-subcategories-form"
    @reset.prevent="handleCancel"
    @submit.prevent="handleSave"
  >
    <fieldset>
      <label>
        <span class="required">Name</span>

        <input
          autofocus
          :disabled="disabled"
          id="admin-service-subcategory-name"
          required
          type="text"
          v-model.trim="name"
        />
      </label>

      <label>
        <span class="required">Category</span>

        <select
          :disabled="disabled"
          id="admin-service-subcategory-category"
          required
          v-model.number="category.id"
        >
          <option disabled></option>

          <option
            v-for="category in filterOptions(categories, subcategory.category)"
            :key="category.id"
            :value="category.id"
          >{{ category.name }}</option>
        </select>
      </label>
    </fieldset>

    <footer>
      <button
        :disabled="!isDeleteEnabled"
        id="admin-service-subcategory-delete"
        type="button"
        @click="handleDelete"
        v-if="canDelete && subcategory.id"
      >Delete</button>

      <button
        :disabled="!isSaveEnabled"
        id="admin-service-subcategory-save"
        type="submit"
        v-if="canSave"
      >Save</button>

      <button
        :disabled="!isCancelEnabled"
        id="admin-service-subcategory-cancel"
        type="reset"
        v-if="canCancel"
      >Cancel</button>
    </footer>
  </form>
</template>

<script>
import {
  deleteServiceSubcategory,
  saveServiceSubcategory
} from "../../api/ServiceAPI";

export default {
  data() {
    return {
      name: undefined,
      category: {}
    };
  },

  props: {
    categories: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    subcategory: {
      type: Object
    }
  },

  computed: {
    canCancel() {
      return true;
    },
    canDelete() {
      return this.can("DELETE_SERVICE_SUBCATEGORIES");
    },
    canSave() {
      return this.can({
        permissions: [
          "CREATE_SERVICE_SUBCATEGORIES",
          "UPDATE_SERVICE_SUBCATEGORIES"
        ],
        matchAny: true
      });
    },
    isCancelEnabled() {
      return !this.disabled;
    },
    isDeleteEnabled() {
      return (
        !this.disabled && this.subcategory?.id && !this.subcategory?.protected
      );
    },
    isSaveEnabled() {
      return (
        !this.disabled &&
        (this.subcategory?.id
          ? this.can("UPDATE_SERVICE_SUBCATEGORIES")
          : this.can("CREATE_SERVICE_SUBCATEGORIES"))
      );
    }
  },

  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    async handleDelete() {
      if (
        !confirm("Are you sure you want to delete this service subcategory?")
      ) {
        return;
      }

      await deleteServiceSubcategory(this.subcategory);
      this.$emit("delete", this.subcategory);
    },
    async handleSave() {
      try {
        this.$emit(
          "save",
          await saveServiceSubcategory({
            ...this.subcategory,
            name: this.name,
            category: this.category
          })
        );
      } catch (e) {
        this.showErrors(e, "An service subcategory");
      }
    },
    isDirty() {
      if (this.disabled) {
        return false;
      }

      return (
        this.name !== this.subcategory?.name ||
        this.category.id !== this.subcategory?.category?.id
      );
    }
  },

  watch: {
    disabled(to, from) {
      !to && from && this.autofocus();
    },
    subcategory: {
      immediate: true,
      handler(to, from) {
        if (to !== from) {
          this.name = to?.name;
          this.category = { ...to?.category };
        }

        !this.disabled && this.autofocus();
      }
    }
  }
};
</script>

<style>
.admin-service-subcategories-form {
  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 0.5em;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-service-subcategories-form > footer {
  grid-column: span 2;
  margin: 0;
  padding: 0.5em 0 0 0;
}
</style>